const onBack = (fallback: string): void => {
  if (document.referrer === '' || document.referrer === document.URL)
    window.location.href = fallback
  else window.location.href = document.referrer
}

export { onBack }
